import { DefaultButton, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import Theme from './Theme';

const defaultComponentStyles = {
  button: {
    selectors: {
      i: {
        fontWeight: 'bold',
        fontSize: '15px',
        height: '25px',
      },
    },
  },
};

export default ({ menuItems, styles }) => {
  const componentStyles = mergeStyleSets({
    ...defaultComponentStyles,
    ...styles,
  });

  return (
    <DefaultButton
      text=""
      title="Actions"
      menuIconProps={{ iconName: 'MoreVertical' }}
      className={[Theme.styles.iconButtonClearMinimalistic, componentStyles.button].join(' ')}
      menuProps={{
        items: menuItems,
      }}
    />
  );
};
